import { render, staticRenderFns } from "./modulo-opciones.vue?vue&type=template&id=7643fc13"
import script from "./modulo-opciones.vue?vue&type=script&lang=js"
export * from "./modulo-opciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports